import { ReactComponent as IconSvg } from 'approot/shared/inline-svg/activity-builder/icon_align_distribute.svg';
import Icon, { IconProps } from '../../icons/icon';

const IconAlignDistribute = (props: IconProps) => {
  return <Icon {...props} Svg={IconSvg} />;
};

export default IconAlignDistribute;
